export default {
  setSettlementMethodToCashTips: lang.templateByUuid("UID:P_UDHWN_17E3A78E05800009","设置'直接抵现'类型费用单的结算方式") /* "设置"直接抵现"类型费用单的结算方式" */,
  settlementMethodTitle: lang.templateByUuid("UID:P_UDHWN_17E3A78E0580000A","结算方式") /* "结算方式" */,
  settleSuccess: lang.templateByUuid("UID:P_UDHWN_17E3A78E0580000B","设置成功") /* "设置成功" */
};
